
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nos-actualites",
      function () {
        return require("private-next-pages/nos-actualites/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nos-actualites"])
      });
    }
  